import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, formValueSelector } from "redux-form";

const renderError = ({ meta: { touched, error } }) =>
  touched && error ? <span className="help is-danger">{error}</span> : false;

renderError.propTypes = {
  meta: PropTypes.shape()
};
renderError.defaultProps = {
  meta: {}
};
const renderInputText = ({ input, className, meta: { touched, error } }) => (
  <input
    {...input}
    type="text"
    className={touched && error ? `${className || ""} is-danger` : className}
  />
);

renderInputText.propTypes = {
  input: PropTypes.shape(),
  className: PropTypes.string.isRequired,
  meta: PropTypes.shape()
};
renderInputText.defaultProps = {
  input: null,
  meta: {}
};

const renderRadioWithLabel = ({
  input,
  name,
  label,
  optionValue,
  multiline,
  textStrong,
  columns,
  radioId,
  meta: { touched, error }
}) => (
  <div
    className={`${multiline ? "is-block" : "is-inline-block"} ${columns &&
      "column has-text-centered"}`}
  >
    <label
      htmlFor={radioId}
      className={`is-medium ${
        touched && error
          ? "radio control radio-padding has-text-danger"
          : "radio control radio-padding"
      }`}
    >
      <input
        {...input}
        checked={optionValue === input.value}
        name={name}
        type="radio"
        id={radioId}
        value={optionValue}
      />
      <span>{textStrong ? <strong>{label}</strong> : label}</span>
    </label>
  </div>
);

renderRadioWithLabel.propTypes = {
  meta: PropTypes.shape(),
  input: PropTypes.shape(),
  name: PropTypes.string,
  label: PropTypes.string,
  optionValue: PropTypes.string,
  multiline: PropTypes.bool.isRequired,
  textStrong: PropTypes.bool.isRequired,
  radioId: PropTypes.string,
  columns: PropTypes.bool
};
renderRadioWithLabel.defaultProps = {
  columns: false,
  meta: {},
  radioId: "",
  name: "",
  input: null,
  optionValue: "",
  label: ""
};

const renderInput = question => {
  switch (question.getType()) {
    case "checkbox":
      return (
        <label className="control" htmlFor={question.getId()}>
          <Field
            name={question.getId()}
            id={question.getId()}
            component="input"
            type="checkbox"
            onChange={value => {
              question.onChange(value);
            }}
          />
          <span />
          <Field name={question.getId()} component={renderError} />
        </label>
      );
    case "radio": {
      const radioList = question.getRadioOptions().map(option => (
        <Field // nie wolno tutaj dac type="radio" jesli wlasny component
          key={question.getId() + option.value}
          radioId={question.getId() + option.value}
          name={question.getId()}
          optionValue={option.value}
          label={option.name}
          multiline={question.multiline()}
          textStrong={question.textStrong()}
          columns={question.options.columns}
          component={renderRadioWithLabel}
        />
      ));
      return (
        <div>
          <div
            className={
              question.multiline()
                ? "field is-grouped is-block"
                : "field is-grouped is-grouped-multiline"
            }
          >
            {radioList}
          </div>
          <Field name={question.getId()} component={renderError} />
        </div>
      );
    }
    case "text":
      return (
        <div>
          <Field
            name={question.getId()}
            component={renderInputText}
            className="input is-medium"
            type={question.getType()}
          />
          <Field name={question.getId()} component={renderError} />
        </div>
      );
    case "select":
      return (
        <div>
          <div className="select">
            <Field
              name={question.getId()}
              component="select"
              className="select is-medium"
            >
              {question.getRadioOptions().map(option => (
                <option
                  key={question.getId() + option.value}
                  value={option.value}
                >
                  {option.name}
                </option>
              ))}
            </Field>
          </div>
          <Field name={question.getId()} component={renderError} />
        </div>
      );
    case "choice_names":
      return (
        <div className="columns has-text-centered">
          {question.getRadioOptions().map(element => (
            <div key={element} className="column">
              <strong>{element}</strong>
            </div>
          ))}
        </div>
      );
    default:
      return (
        <div>
          <Field
            name={question.getId()}
            component="input"
            type={question.getType()}
          />

          <Field name={question.getId()} component={renderError} />
        </div>
      );
  }
};
const PollQuestion = props => {
  const { question, observed } = props;
  return (
    !question.hide(observed) &&
    (question.getType() === "justlabel" ? (
      <div id={question.options.htmlId} style={question.options.htmlStyle}>
        {question.getLabel() ? (
          <p>
          {question.labelStrong() ? (
            <strong dangerouslySetInnerHTML={{ __html: question.getLabel() }} />
          ) : (
            <span dangerouslySetInnerHTML={{ __html: question.getLabel() }} />
          )}
        </p>
         ) : (
         <span/>
         )
       }
       { question.options.info ? (
        <p
          className="m-top-20"
          dangerouslySetInnerHTML={{ __html: question.options.info }}
        />
        ) : (
        <span/>
        )
      }
      </div>
    ) : (
      <div
        className={`${
          question.getType() === "choice_names" ? "m-top-20" : ""
        } columns ${question.options.topLine && "top-border"}  ${question
          .options.bottomLine && "bottom-border"}`}
      >
        <div
          className={`column ${question.getLabelWidth()} ${question.getLabelAlign()}`}
        ><p>
          {question.labelStrong() ? (
            <strong dangerouslySetInnerHTML={{ __html: question.getLabel() }} />
          ) : (
            <span dangerouslySetInnerHTML={{ __html: question.getLabel() }} />
          )}
          </p>
        </div>
        <div className="column">{renderInput(question)}</div>
      </div>
    ))
  );
};

function mapStateToProps(state, props) {
  const { question } = props;
  const selector = formValueSelector("pollForm");

  if (question.depending()) {
    const observed = selector(state, ...props.question.dependsOn());
    return { observed };
  }
  return {};
}

export default connect(mapStateToProps, {})(PollQuestion);



// WEBPACK FOOTER //
// ./src/components/poll/PollQuestion.js